import { AuthSession } from '../models/auth.models';

export interface MockAuthAccount extends AuthSession {
  password: string;
}

export const MOCK_AUTH_ACCOUNT: MockAuthAccount = {
  accessToken: 'mock-access-token-voxor',
  password: 'Admin1234!',
  expiresAt: '2099-12-31T23:59:59.000Z',
  user: {
    id: 1,
    companyId: null,
    firstName: 'María',
    lastName: 'López',
    fullName: 'María López',
    email: 'admin@voxor.es',
    roleId: 1,
    status: 1,
    createdAt: '2026-03-26T18:34:13.372047',
    mustChangePassword: false,
  },
};
